module.exports = __webpack_public_path__ + "6e6ee8478d8f386358e132624d4fe159.svg";